loadSwiper().then(() => {
  new Swiper("#hero--swiper", {
    loop: true,
    autoHeight: true,
    autoplay: { delay: 5000 },
    pagination: { el: ".hero-swiper-pagination", clickable: true },
    navigation: {
      nextEl: ".hero-swiper-button-next",
      prevEl: ".hero-swiper-button-prev",
    },
  });
});
